/**
 * Web stub for Firebase Cloud Messaging
 * All messaging operations should be guarded with Platform.OS !== 'web' checks
 */

const messagingStub = {
  getToken: () => Promise.resolve(''),
  requestPermission: () => Promise.resolve(0),
  registerDeviceForRemoteMessages: () => Promise.resolve(),
  onMessage: () => () => {},
  onNotificationOpenedApp: () => () => {},
  getInitialNotification: () => Promise.resolve(null),
  AuthorizationStatus: {
    AUTHORIZED: 1,
    PROVISIONAL: 2,
    DENIED: 0,
  },
};

// Export as a function that returns the stub (mimics Firebase module behavior)
export default () => messagingStub;
